<ng-container *transloco="let t">
  <div class="m-4">
    <!-- Report created product groups -->
    @if (modalData.uploadResult.created || modalData.uploadResult.updated) {
      <div class="alert alert-success">
        <div>
          {{
            t("product-group-bulk-upload-result-modal.create_sucess", { count: modalData.uploadResult.created.length })
          }}
        </div>
        <div>
          {{
            t("product-group-bulk-upload-result-modal.update_sucess", { count: modalData.uploadResult.updated.length })
          }}
        </div>
        <div (click)="toggleSuccessDetails()" class="mt-2">
          <span class="icon-prepend pointer float-left">
            <app-dropdown-toggle-icon [expand]="successDetailsVisible"></app-dropdown-toggle-icon>
          </span>
          <span class="ml-2">{{ t("common.details") }}</span>
        </div>
        @if (successDetailsVisible) {
          <div class="mt-2">
            <ul>
              @for (upload of modalData.uploadResult.created; track upload) {
                <li>
                  {{ t("product-group-bulk-upload-result-modal.product_group") }}
                  <strong>{{ upload.productGroupName }}</strong>
                  {{ t("product-group-bulk-upload-result-modal.product_group_created") }}.
                </li>
              }
            </ul>
            <ul>
              @for (upload of modalData.uploadResult.updated; track upload) {
                <li>
                  {{ t("product-group-bulk-upload-result-modal.product_group") }}
                  <strong>{{ upload.productGroupName }}</strong>
                  {{ t("product-group-bulk-upload-result-modal.product_group_updated") }}.
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
    @if (modalData.uploadResult.errors.length > 0) {
      <div class="alert alert-danger break-words">
        <div>
          {{
            t("product-group-bulk-upload-result-modal.n_error_uploading", {
              count: modalData.uploadResult.errors.length,
              entity: modalData.updatedEntity,
            })
          }}
        </div>
        <div (click)="toggleErrorDetails()" class="mt-2">
          <span class="icon-prepend float-left cursor-pointer">
            <app-dropdown-toggle-icon [expand]="errorDetailsVisible"></app-dropdown-toggle-icon>
          </span>
          <span class="ml-2">{{ t("common.details") }}</span>
        </div>
        @if (errorDetailsVisible) {
          <div class="mt-2">
            <ul>
              @for (error of modalData.uploadResult.errors; track error) {
                <li>
                  {{ error }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    }
    <div class="flex justify-end">
      <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.close") }}</button>
    </div>
  </div>
</ng-container>
